export default __webpack_public_path__ + "media/images/cta_blocks/design_table_plan-f8d08531cebcbcf3d49e166df3bce935.jpg";